import { useCafAnalysisComponentDetailV5 } from '../../../../../modules/apis/webview/caf'
import { n_caf } from '../../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import { useLessonsStack } from '../../../../../pages/[lang]/webview/lessons'
import LoadingSpinner from '../../../../common/LoadingSpinner'
import FluencyIntroSection from '../../../../new-portal/caf/analysis/fluency/FluencyIntroSection'
import FluencyTabsSection from '../../../../new-portal/caf/analysis/fluency/FluencyTabsSection'
import ThickDivider from '../../../../new-portal/caf/common/ThickDivider'
import WebviewStackContainer from '../../../common/WebviewStackContainer'

const AIFluencyActivity = ({ params }) => {
  const { useLessonsFlow } = useLessonsStack()
  const { pop } = useLessonsFlow()
  const { lessonId, componentId } = params
  const { t } = useTranslation()
  const { isLoading } = useCafAnalysisComponentDetailV5(+componentId)

  return (
    <div>
      <WebviewStackContainer height="52px" onBack={pop} title={t(n_caf.overview.fluency)} border={true}>
        {isLoading ? (
          <div className="h-screen">
            <LoadingSpinner lg primary show />
          </div>
        ) : (
          <div className="keep-all min-h-screen overflow-hidden text-gray-700">
            <FluencyIntroSection componentId={componentId} />
            <ThickDivider />
            <div className="bg-gray-50">
              <div className="h-16" />
              <FluencyTabsSection componentId={componentId} />
              <div className="h-[61px]" />
            </div>
          </div>
        )}
      </WebviewStackContainer>
    </div>
  )
}

export default AIFluencyActivity
